import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
  categories: Array<any> = [];
  url = this.apiservice.url + '/uploads/';
  banner: Boolean = true;
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    if (this.apiservice.user.profiles) {
      this.apiservice.getProfileById(this.apiservice.user.profiles._id, this.apiservice.user._id).subscribe((res: any) => {
        this.categories = res.data.categoryMap.map(cat => {
          cat['category']['goals'] = cat['goals'];
          return cat;
        });
        this.categories.sort(function(a, b) {
          return a.rank - b.rank;
        });
      })
    } else {
      this.apiservice.getCreatedCategories(this.apiservice.user._id).subscribe((res: any) => {
        this.categories = res.data.map(cat => {
          cat['category'] = cat;
          return cat;
        });
      });
    }
  }

}
